import React, { useState, useRef } from "react";
import { PrimaryButton } from "widgets";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";
import Loader from "shared/Loader/Loader";
import { useUploadFileService } from "store/backend/apiHooks";
import tokenUtils from "utils/tokenUtils";
import styles from "./FileUpload.module.scss";

const handleFileChange = (event, setSelectedFile) => {
  setSelectedFile(event.target.files[0]);
};

const handleUpload = (
  selectedFile,
  scriptId,
  userId,
  openSnackbar,
  uploadFileService,
  setSelectedFile,
  fileInputRef
) => {
  if (!selectedFile) return;
  uploadFileService(
    { selectedFile, userId, scriptId },
    {
      onSuccess: (data) => {
        if (!data) {
          throw new Error("Received data is undefined");
        }
        if (data.uploaded_file_id) {
          openSnackbar("File Uploaded Successfully!", "success");
          setSelectedFile(null);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        }
      },
      onError: (err) => {
        openSnackbar(err.message || "Create Package failed", "error");
      },
    }
  );
};

const FileUpload = (props) => {
  const { scriptId, uploadLabel } = props;
  const userId = tokenUtils.readUserId();
  const { mutate: uploadFileService, isPending: uploadPackageIsPending } = useUploadFileService();
  const { openSnackbar } = useSnackbarContext();
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef();

  return (
    <div className={styles.mainContainer}>
      <div className={styles.dashedBox}>
        <p>{selectedFile ? selectedFile.name : "Upload your file here."}</p>
        <input
          type="file"
          onChange={(event) => handleFileChange(event, setSelectedFile)}
          ref={fileInputRef}
          className={styles.fileInput}
        />
      </div>
      <PrimaryButton
        disabled={!selectedFile}
        onClick={() =>
          handleUpload(
            selectedFile,
            scriptId,
            userId,
            openSnackbar,
            uploadFileService,
            setSelectedFile,
            fileInputRef
          )
        }
      >
        {uploadPackageIsPending ? <Loader /> : uploadLabel}
      </PrimaryButton>
    </div>
  );
};

export default FileUpload;
